import { QuoteexpiredIcon } from "icons/warning/Quoteexpired";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { encode, decode } from "utils/HelperFunctions";
import { useTestAttrsFactory } from "utils/testid";

const InvoiceCanceled = () => {
  const { id: actionId } = useParams();
  let slug = decode(actionId || "")?.split("_");
  let cluster_id = encode(slug[1], "ci_");

  const navigate = useNavigate();
  const testAttrs = useTestAttrsFactory();
  return (
    <div
      className="h-full w-full grid place-items-center"
      {...testAttrs("canceled", "Invoice canceled")}
    >
      <div className="w-full flex justify-center items-center lg:px-[30px] gap-10 flex-col">
        <QuoteexpiredIcon width="99" height="105" aria-hidden="true" />
        <div className="w-full flex flex-col gap-4 justify-center items-center">
          <div className=" grid place-items-center text-txtPrimary lg:text-2xl text-xl font-medium leading-[31.25px]">
            Invoice canceled
          </div>
          <div className="text-base text-txtParagraph leading-[20.83px] text-center lg:px-4">
            This invoice has been canceled. If you have any questions, please
            reach out to us.
          </div>
        </div>
        <div className="text-blue w-full grid place-items-center">
          <span
            className="cursor-pointer hover:!text-btnPrimaryHover lg:text-base text-sm"
            role="button"
            tabIndex={0}
            {...testAttrs("back-to-dashboard", "Back to dashboard")}
            onClick={() => {
              let encodedString = encode(slug[1], "ci_");
              navigate(`/${encodedString}/dashboard`);
            }}
          >
            {" "}
            Back to dashboard
          </span>
        </div>
      </div>
    </div>
  );
};

export default InvoiceCanceled;
